import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'button',
    'modalExpanderButton',
    'modal'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    display: 'inline-flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    border: 'none',
    background: 'none',
    margin: '0 15px',
    padding: '4px 2px',
    borderBottom: '1px solid #dee2e6',
    cursor: 'pointer',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Modal/StyledComponents/ModalExpanderButton.tsx